module.exports = __webpack_public_path__ + "img/shield-purple.15bea1ea.svg";